import { useNuxtApp, useRouter } from "#app";
function formatComponentName(vm, includeFile) {
  if (vm.$root === vm) {
    return "<Root>";
  }
  const options = typeof vm === "function" && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
  let name = options.name || options._componentTag;
  const file = options.__file;
  if (!name && file) {
    const match = file.match(/([^/\\]+)\.vue$/);
    name = match && match[1];
  }
  return (name ? "<" + classify(name) + ">" : "<Anonymous>") + (file && includeFile !== false ? " at " + file : "");
}
function classify(str) {
  return str.replace(/(?:^|[-_])(\w)/g, (c) => c.toUpperCase()).replace(/[-_]/g, "");
}
function getException(err) {
  const errVal = err;
  if (errVal) {
    return errVal;
  }
  const strVal = err;
  if (strVal) {
    return new Error(strVal);
  }
  return void 0;
}
export function setupVueErrorHandling(appInsights) {
  const nuxtApp = useNuxtApp();
  const oldErrorHandler = nuxtApp.vueApp.config.errorHandler;
  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    appInsights.trackException({
      exception: getException(err),
      properties: {
        errorInfo: info,
        component: instance ? formatComponentName(instance, true) : void 0,
        props: instance ? instance.$options.propsData : void 0
      }
    });
    appInsights.flush();
    if (typeof oldErrorHandler === "function") {
      oldErrorHandler.call(instance, err, instance, info);
    }
  };
}
export function setupPageTracking(client) {
  const router = useRouter();
  router.beforeEach((to, _, next) => {
    client?.startTrackPage(to.name?.toString());
    next();
  });
  router.afterEach((to) => {
    client?.stopTrackPage(to.name?.toString(), to.fullPath);
  });
}
export function setupConsoleLogging(client) {
  const nuxtApp = useNuxtApp();
  nuxtApp.hooks.addHooks({
    "app:mounted": () => {
      const trace = (severityLevel, args) => {
        client?.trackTrace({
          severityLevel,
          message: args.join(" ")
        });
      };
      const originalConsoleLog = console.log;
      console.log = (...args) => {
        originalConsoleLog(...args);
        trace(0, args);
      };
      const originalConsoleTrace = console.trace;
      window.console.trace = (...args) => {
        originalConsoleTrace(...args);
        trace(0, args);
      };
      const originalConsoleDebug = console.debug;
      console.debug = (...args) => {
        originalConsoleDebug(...args);
        trace(0, args);
      };
      const originalConsoleInfo = console.info;
      console.info = (...args) => {
        originalConsoleInfo(...args);
        trace(1, args);
      };
      const originalConsoleWarn = console.warn;
      console.warn = (...args) => {
        originalConsoleWarn(...args);
        trace(2, args);
      };
      const originalConsoleError = console.error;
      console.error = (...args) => {
        originalConsoleError(...args);
        trace(3, args);
      };
    }
  });
}
